import { isInteger } from 'lodash-es';

export const toPrecision = (value: number | null, fractionDigits = 1) => {
	if (!value) {
		return value;
	}

	return isInteger(value) ? value.toString() : value.toFixed(fractionDigits);
};
